//childBasedSizing
import {EnrichedAstNode, AstView} from '../../types';
import {visitorEnriched, visitorPostOrder} from '../../helpers';
import {getGroupDimensions} from '../../helpers/GeometryHelpers';
import {removeNodeFromView} from '../../Ast/GroupingUtilities';

export function resizeDynamicSizedGroups(tree: EnrichedAstNode) {
    visitorEnriched(tree, (node) => {
        if (node.userInput.childBasedSizing) {
            const {zIndex, position: geoPosition} = getGroupDimensions(node.children);
            node.innerPosition = {
                ...node.innerPosition,
                ...geoPosition,
            };
            node.position = {
                ...node.position,
                ...geoPosition,
            };
            node.zIndex = zIndex;
        }
    });
}

export function removeDeadUserGroups(tree: EnrichedAstNode, view: AstView) {
    visitorPostOrder(tree, view.meta, (node) => {
        if (node.meta.userCreateGroup && node.children.length < 2) {
            // remove
            removeNodeFromView(view, node.internalId);
        }
    });
}

export function removeAllSystemGroups(tree: EnrichedAstNode, view: AstView) {
    visitorPostOrder(tree, view.meta, (node) => {
        if (node.meta.systemGenerated) {
            if (Object.keys(node.inputLayoutAbstraction).length > 0) {
                // if user input promote
                node.userInput.lockChildren = true;
                node.userInput.childBasedSizing = false;
                node.meta.systemGenerated = false;
                node.meta.userCreateGroup = true;
            } else {
                // else remove
                removeNodeFromView(view, node.internalId);
            }
        }
    });
}
